var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 99,
    viewBox: "0 0 153 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0839 59.9456L35.4961 31.7194C35.4961 31.7194 85.3981 9.55181 123.223 30.3241C132.835 35.6016 141.668 43.6655 148.701 55.5414L148.784 55.5485L148.74 55.6036L148.774 55.6653L148.681 55.6574C139.707 66.2046 129.61 72.6556 119.22 76.1796C78.4467 90.2006 33.0839 59.9456 33.0839 59.9456Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.689 31.1555C124.201 30.8687 123.712 30.5916 123.223 30.3242C117.211 36.2845 113.524 44.1759 112.818 52.5927C112.097 60.9585 114.368 69.3117 119.23 76.1806C119.783 75.9926 120.333 75.7847 120.887 75.5869C122.068 75.1486 123.246 74.6676 124.421 74.1438C132.971 70.3498 141.22 64.4173 148.674 55.6275L148.777 55.6363L148.743 55.5746L148.784 55.5487L148.691 55.5408C142.832 45.6133 135.704 38.3666 127.932 33.1729",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.689 31.1555C124.201 30.8687 123.712 30.5916 123.223 30.3242C117.211 36.2845 113.524 44.1759 112.818 52.5927C112.097 60.9585 114.368 69.3117 119.23 76.1806C119.783 75.9926 120.333 75.7847 120.887 75.5869C122.068 75.1486 123.246 74.6676 124.421 74.1438C132.971 70.3498 141.22 64.4173 148.674 55.6275L148.777 55.6363L148.743 55.5746L148.784 55.5487L148.691 55.5408C142.832 45.6133 135.704 38.3666 127.932 33.1729",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2022 74.1231C50.9217 45.6217 67.5853 22.8342 67.5853 22.8342L54.1241 6.93823C54.1241 6.93823 29.5416 -2.40792 7.79257 4.97391L44.1114 28.4852L64.3231 23.3496",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2022 74.1231C50.9217 45.6217 67.5853 22.8342 67.5853 22.8342L54.1241 6.93823C54.1241 6.93823 29.5416 -2.40792 7.79257 4.97391L44.1114 28.4852L64.3231 23.3496",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6144 22.4932C50.6759 48.4975 63.2308 73.7869 63.2308 73.7869L47.2684 87.1585C47.2684 87.1585 21.4561 92.2029 1.27538 81.2328L41.0566 64.2299L60.1037 72.7206",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6144 22.4932C50.6759 48.4975 63.2308 73.7869 63.2308 73.7869L47.2684 87.1585C47.2684 87.1585 21.4561 92.2029 1.27539 81.2328L41.0566 64.2299L60.1037 72.7206",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.147 52.728C115.058 53.7735 115.838 54.6939 116.889 54.7837C117.94 54.8735 118.865 54.0988 118.954 53.0533C119.043 52.0077 118.264 51.0873 117.212 50.9975C116.161 50.9077 115.237 51.6824 115.147 52.728Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.885 75.6114C121.042 76.0108 121.33 76.3458 121.702 76.562C122.075 76.7782 122.51 76.8628 122.936 76.8022C123.363 76.7415 123.756 76.5391 124.052 76.2279C124.348 75.9166 124.53 75.5149 124.567 75.0878C124.593 74.774 124.542 74.4585 124.419 74.1683",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.885 75.6114C121.042 76.0108 121.33 76.3458 121.702 76.562C122.075 76.7782 122.51 76.8628 122.936 76.8022C123.363 76.7415 123.756 76.5391 124.052 76.2279C124.348 75.9166 124.53 75.5149 124.567 75.0878C124.593 74.774 124.542 74.4585 124.419 74.1683",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.244 46.4731C116.154 47.5186 116.934 48.439 117.985 48.5288C119.036 48.6187 119.961 47.8439 120.05 46.7984C120.14 45.7528 119.36 44.8325 118.309 44.7426C117.258 44.6528 116.333 45.4275 116.244 46.4731Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.861 40.7651C118.771 41.8106 119.551 42.731 120.602 42.8208C121.653 42.9106 122.578 42.1359 122.667 41.0904C122.757 40.0448 121.977 39.1244 120.926 39.0346C119.875 38.9448 118.95 39.7195 118.861 40.7651Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.326 35.1694C122.236 36.2149 123.016 37.1353 124.067 37.2251C125.118 37.3149 126.043 36.5402 126.132 35.4947C126.221 34.4491 125.442 33.5287 124.391 33.4389C123.339 33.3491 122.415 34.1238 122.326 35.1694Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.932 33.1732C126.863 32.4609 125.787 31.7888 124.704 31.1571C124.885 30.8516 125.15 30.6035 125.467 30.4415C125.785 30.2796 126.142 30.2103 126.497 30.2417C127.002 30.2848 127.469 30.5256 127.796 30.9111C128.122 31.2967 128.282 31.7953 128.239 32.2974C128.212 32.6103 128.106 32.9115 127.932 33.1732Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.166 59.0824C115.077 60.128 115.857 61.0484 116.908 61.1382C117.959 61.228 118.883 60.4533 118.973 59.4078C119.062 58.3622 118.282 57.4418 117.231 57.352C116.18 57.2622 115.256 58.0369 115.166 59.0824Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.777 65.1518C116.687 66.1973 117.467 67.1177 118.518 67.2075C119.569 67.2974 120.494 66.5226 120.583 65.4771C120.672 64.4316 119.893 63.5112 118.842 63.4213C117.79 63.3315 116.866 64.1063 116.777 65.1518Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.242 71.2553C119.152 72.3008 119.932 73.2212 120.983 73.3111C122.034 73.4009 122.959 72.6261 123.048 71.5806C123.138 70.5351 122.358 69.6147 121.307 69.5248C120.256 69.435 119.331 70.2098 119.242 71.2553Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1954 48.9861C70.4275 57.9712 77.128 65.8809 86.1612 66.6528C95.1945 67.4248 103.14 60.7668 103.908 51.7817C104.676 42.7966 97.9752 34.8869 88.9419 34.1149C79.9087 33.3429 71.9633 40.001 71.1954 48.9861Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9853 49.3959C75.4423 55.7497 80.1805 61.343 86.5683 61.8889C92.9562 62.4348 98.5748 57.7266 99.1178 51.3728C99.6608 45.0189 94.9226 39.4256 88.5347 38.8797C82.1468 38.3338 76.5283 43.042 75.9853 49.3959Z",
    fill: "#70FF00",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.144 48.2126C62.6924 54.5979 46.9286 61.0892 4.35765 45.1664C4.35765 45.1664 60.8097 32.5686 62.144 48.2126Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.3792,
    height: 146.043,
    fill: "white",
    transform: "translate(152.868 12.4355) rotate(94.8846)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.51bc6ac209b6b218af3613e4b4a9c4fe.svg";
export { ForwardRef as ReactComponent };